"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var _react = _interopRequireDefault(require("react"));
var _propTypes = _interopRequireDefault(require("prop-types"));
var _MenuContext = _interopRequireDefault(require("./MenuContext"));
var _ark = require("@dateam/ark");
var _arkReact = require("@dateam/ark-react");
const MenuList = _ref => {
  let {
    className,
    containerRef,
    children
  } = _ref;
  const [hoverIndex, hoverIndexDispatch] = _react.default.useReducer(hoverIndexReducer, -1);
  const menuRef = _react.default.useRef(null);
  const context = _react.default.useMemo(() => ({
    hoverIndex,
    hoverIndexDispatch
  }), [hoverIndex, hoverIndexDispatch]);
  function hoverIndexReducer(state, action) {
    return action.index;
  }
  const menuItems = _react.default.useMemo(() => {
    let index = 0;
    const items = _react.default.Children.map(children, child => {
      if (child === null) return null;
      return /*#__PURE__*/_react.default.cloneElement(child, {
        index: index++
      });
    });
    return items;
  }, [children]);
  _react.default.useEffect(() => {
    if (!(0, _ark.isDefined)(containerRef.current) || !(0, _ark.isDefined)(menuRef.current)) {
      return;
    }
    const containerRect = containerRef.current.getBoundingClientRect();
    const left = containerRect.width;
    const top = 0;
    menuRef.current.setAttribute('style', `opacity: 1; left: ${left.toFixed()}px; top: ${top.toFixed()}px;`);
  }, [menuRef, containerRef]);
  return /*#__PURE__*/_react.default.createElement("ul", {
    ref: menuRef,
    className: (0, _arkReact.concatClassName)('menu', className)
  }, /*#__PURE__*/_react.default.createElement(_MenuContext.default.Provider, {
    value: context
  }, menuItems));
};
process.env.NODE_ENV !== "production" ? MenuList.propTypes = {
  className: _propTypes.default.string,
  containerRef: _propTypes.default.any,
  children: _propTypes.default.node
} : void 0;
MenuList.defaultProps = {
  className: undefined,
  containerRef: undefined,
  children: undefined
};
var _default = exports.default = MenuList;